export default "__VITE_ASSET__DRxn68LQ__"